import type {
  INeoProjectController,
  INeoProjectService,
} from "../../core/ports/driver/neoProjectService";

/**
 * Neo Projects controller. The project aggregate (projects, agents, files,
 * instructions, memories, tasks, activity, sharing) needs no extra
 * presentation-layer adaptation beyond what the service provides, so the
 * controller exposes the service surface directly — kept as its own factory
 * for consistency with the rest of the hexagon (page → controller → service →
 * repository).
 */
export const NeoProjectControllerFactory = ({
  neoProjectService,
}: {
  neoProjectService: INeoProjectService;
}): INeoProjectController => {
  return {
    listProjects: neoProjectService.listProjects,
    createProject: neoProjectService.createProject,
    listTemplates: neoProjectService.listTemplates,
    listPromptSuggestions: neoProjectService.listPromptSuggestions,
    cloneTemplate: neoProjectService.cloneTemplate,
    updateProject: neoProjectService.updateProject,
    deleteProject: neoProjectService.deleteProject,
    getProjectShare: neoProjectService.getProjectShare,
    setProjectShareClinics: neoProjectService.setProjectShareClinics,
    getAiCareSnfSettings: neoProjectService.getAiCareSnfSettings,
    setAiCareSnfEnabled: neoProjectService.setAiCareSnfEnabled,
    getProjectOwners: neoProjectService.getProjectOwners,
    setProjectOwners: neoProjectService.setProjectOwners,
    listProjectActivity: neoProjectService.listProjectActivity,
    listProjectAgents: neoProjectService.listProjectAgents,
    listProjectFiles: neoProjectService.listProjectFiles,
    listProjectWorkflowDocuments:
      neoProjectService.listProjectWorkflowDocuments,
    listAgentFiles: neoProjectService.listAgentFiles,
    addProjectFile: neoProjectService.addProjectFile,
    addAgentFile: neoProjectService.addAgentFile,
    patchAgentFile: neoProjectService.patchAgentFile,
    deleteProjectFile: neoProjectService.deleteProjectFile,
    deleteAgentFile: neoProjectService.deleteAgentFile,
    listProjectInstructions: neoProjectService.listProjectInstructions,
    listAgentInstructions: neoProjectService.listAgentInstructions,
    createAgentInstruction: neoProjectService.createAgentInstruction,
    updateAgentInstruction: neoProjectService.updateAgentInstruction,
    deleteAgentInstruction: neoProjectService.deleteAgentInstruction,
    listProjectMemories: neoProjectService.listProjectMemories,
    listAgentMemories: neoProjectService.listAgentMemories,
    deleteAgentMemory: neoProjectService.deleteAgentMemory,
    listProjectTasks: neoProjectService.listProjectTasks,
    createProjectTask: neoProjectService.createProjectTask,
    updateProjectTask: neoProjectService.updateProjectTask,
    deleteProjectTask: neoProjectService.deleteProjectTask,
    runProjectTask: neoProjectService.runProjectTask,
  };
};
